import {
  HHIconButton,
  HHStack,
  HHTextField,
  HHTooltip,
} from '@hinge-health/react-component-library';
import { InfoOutlined } from '@mui/icons-material';
import { Controller, useFormContext } from 'react-hook-form';

const GSheetUrlInput = (): JSX.Element => {
  const { control } = useFormContext();

  return (
    <HHStack direction="row" spacing={2} width="100%">
      <Controller
        control={control}
        name="googleSheetsUrl"
        render={({ field: { onChange, value } }): JSX.Element => (
          <HHTextField
            fullWidth
            sx={{ minWidth: 230 }}
            variant="outlined"
            hhVariant="variant-bypass"
            type="text"
            placeholder="Enter google sheet URL"
            InputProps={{
              startAdornment: (
                <HHTooltip
                  hhVariant="variant-bypass"
                  title="Upload a google sheet URL to ingest into billing."
                >
                  <HHIconButton hhVariant="variant-bypass">
                    <InfoOutlined />
                  </HHIconButton>
                </HHTooltip>
              ),
            }}
            value={value}
            onChange={onChange}
          />
        )}
      />
    </HHStack>
  );
};

export default GSheetUrlInput;
